// store/reducers/agentsReducer.ts
import {
    FETCH_AGENTS_REQUEST,
    FETCH_AGENTS_SUCCESS,
    FETCH_AGENTS_FAILURE
} from '../../actions';

const initialState = {
    loading: false,
    agents: [],
    error: null,
};

const agentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AGENTS_REQUEST:
            return { ...state, loading: true };
        case FETCH_AGENTS_SUCCESS:
            return { ...state, loading: false, agents: action.payload };
        case FETCH_AGENTS_FAILURE:
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};



export default agentsReducer;
